// Offline data cache — slaat API-data op in localStorage

const KEYS = {
  DIVES:          'oc_dives',
  STATS:          'oc_stats',
  SUGGESTIONS:    'oc_suggestions',
  dive:    (id) => `oc_dive_${id}`,
  profile: (id) => `oc_profile_${id}`,
  photos:  (id) => `oc_photos_${id}`,
};

export const offlineCache = {
  set(key, data) {
    try {
      localStorage.setItem(key, JSON.stringify({ data, ts: Date.now() }));
    } catch (e) {
      // localStorage vol — negeer stilletjes
    }
  },

  get(key) {
    try {
      const raw = localStorage.getItem(key);
      if (!raw) return null;
      return JSON.parse(raw).data;
    } catch (e) {
      return null;
    }
  },

  KEYS,
};

export default offlineCache;
